var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7502 7.5551C12.0828 8.2097 11.0007 8.2097 10.3333 7.5551L12.727 5.20732C14.3794 3.58652 17.0716 3.59925 18.7401 5.23576C20.4086 6.87228 20.4216 9.51286 18.7691 11.1337L16.3755 13.4814C14.723 15.1022 12.0308 15.0895 10.3623 13.453C11.0233 12.8047 12.1232 12.8825 13.0503 12.9998C13.8046 13.0953 14.5911 12.8611 15.167 12.2962L17.5607 9.94839C18.5522 8.97591 18.5444 7.39156 17.5433 6.40965C16.5422 5.42775 14.9269 5.4201 13.9354 6.39259L12.7502 7.5551Z",
    fill: "#8E9193"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83297 11.7038L6.43933 14.0516C5.44785 15.0241 5.45564 16.6084 6.45673 17.5903C7.45782 18.5723 9.07311 18.5799 10.0646 17.6074L11.2498 16.4449C11.9172 15.7903 12.9993 15.7903 13.6667 16.4449L11.273 18.7927C9.62055 20.4135 6.92839 20.4007 5.25991 18.7642C3.59142 17.1277 3.57844 14.4871 5.2309 12.8663L7.62455 10.5186C9.27701 8.89776 11.9692 8.9105 13.6377 10.547C12.9767 11.1953 11.8768 11.1175 10.9497 11.0002C10.1954 10.9047 9.40894 11.1389 8.83297 11.7038Z",
    fill: "#8E9193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSmall);
export default __webpack_public_path__ + "static/media/link_small.cc04a0fe.svg";
export { ForwardRef as ReactComponent };var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7502 7.5551C12.0828 8.2097 11.0007 8.2097 10.3333 7.5551L12.727 5.20732C14.3794 3.58652 17.0716 3.59925 18.7401 5.23576C20.4086 6.87228 20.4216 9.51286 18.7691 11.1337L16.3755 13.4814C14.723 15.1022 12.0308 15.0895 10.3623 13.453C11.0233 12.8047 12.1232 12.8825 13.0503 12.9998C13.8046 13.0953 14.5911 12.8611 15.167 12.2962L17.5607 9.94839C18.5522 8.97591 18.5444 7.39156 17.5433 6.40965C16.5422 5.42775 14.9269 5.4201 13.9354 6.39259L12.7502 7.5551Z",
    fill: "#8E9193"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83297 11.7038L6.43933 14.0516C5.44785 15.0241 5.45564 16.6084 6.45673 17.5903C7.45782 18.5723 9.07311 18.5799 10.0646 17.6074L11.2498 16.4449C11.9172 15.7903 12.9993 15.7903 13.6667 16.4449L11.273 18.7927C9.62055 20.4135 6.92839 20.4007 5.25991 18.7642C3.59142 17.1277 3.57844 14.4871 5.2309 12.8663L7.62455 10.5186C9.27701 8.89776 11.9692 8.9105 13.6377 10.547C12.9767 11.1953 11.8768 11.1175 10.9497 11.0002C10.1954 10.9047 9.40894 11.1389 8.83297 11.7038Z",
    fill: "#8E9193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSmall);
export default __webpack_public_path__ + "static/media/link_small.cc04a0fe.svg";
export { ForwardRef as ReactComponent };